import { render, staticRenderFns } from "./AvailablePackagesPanel.vue?vue&type=template&id=a4aca9d0&"
import script from "./AvailablePackagesPanel.vue?vue&type=script&lang=js&"
export * from "./AvailablePackagesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports